'use client'

import { Label, Divider, Cell, Card } from '@vinted/web-ui'

import { FormattedMessage } from '@marketplace-web/i18n/i18n-feature'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import CountrySelect from './CountrySelect'
import CitySelect from './CitySelect'
import CityVisibilityToggle from './CityVisibilityToggle'

type LocationSettings = {
  countryId: number | null
  cityId: number | null
  cityTitle: string | null
  isCityVisible: boolean
}

type Props = {
  settings: LocationSettings
  onLocationChange: (updates: Partial<LocationSettings>) => void
}

const Location = ({ settings, onLocationChange }: Props) => {
  const handleCountryChange = (
    countryId: number,
    cityId: number | null,
    cityTitle: string | null,
  ) => {
    onLocationChange({ countryId, cityId, cityTitle })
  }

  const handleCityChange = (cityId: number, cityTitle: string) => {
    onLocationChange({ cityId, cityTitle })
  }

  const handleCityVisibilityChange = (isCityVisible: boolean) => {
    onLocationChange({ isCityVisible })
  }

  return (
    <>
      <Label text={<FormattedMessage id="profile_settings.location.title" />} />
      <Card overflow="visible">
        <Cell styling={Cell.Styling.Tight}>
          <SeparatedList separator={<Divider />}>
            <CountrySelect countryId={settings.countryId} onCountryChange={handleCountryChange} />
            <CitySelect
              cityId={settings.cityId}
              cityTitle={settings.cityTitle}
              countryId={settings.countryId}
              onCityChange={handleCityChange}
            />
            <CityVisibilityToggle
              isCityVisible={settings.isCityVisible}
              onCityVisibilityChange={handleCityVisibilityChange}
            />
          </SeparatedList>
        </Cell>
      </Card>
    </>
  )
}

export default Location
